/** Chave do localStorage com o id da última versão de novidades que o usuário fechou. */
export const WHATS_NEW_STORAGE_KEY = "whatsNew:lastSeenRelease";

const getStorage = (): Storage | null => {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
};

/** Id da última versão vista, ou null se nada foi gravado ou o storage está indisponível. */
export function readLastSeenRelease(storage: Storage | null = getStorage()): string | null {
  try {
    return storage?.getItem(WHATS_NEW_STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

/** Grava a versão como vista; com o storage bloqueado, o modal volta a abrir no próximo carregamento. */
export function markReleaseSeen(releaseId: string, storage: Storage | null = getStorage()): void {
  try {
    storage?.setItem(WHATS_NEW_STORAGE_KEY, releaseId);
  } catch {
    // Sem storage não há onde guardar; nada a fazer.
  }
}

/** Indica se a versão ainda não foi vista pelo usuário neste navegador. */
export function shouldShowRelease(releaseId: string, storage: Storage | null = getStorage()): boolean {
  return readLastSeenRelease(storage) !== releaseId;
}
